var Agenda = (function () {
    function Agenda(expediente, caratula, organismosecretaria, decreto, fecha, sala, exp_id, novedad) {
        this.expediente = expediente;
        this.caratula = caratula;
        this.organismosecretaria = organismosecretaria;
        this.decreto = decreto;
        this.fecha = fecha;
        this.sala = sala;
        this.exp_id = exp_id;
        this.novedad = novedad;
    }
    return Agenda;
}());
export { Agenda };
var AgendaPage = (function () {
    function AgendaPage(page, size, total, data) {
        this.page = page;
        this.size = size;
        this.total = total;
        this.data = data;
    }
    return AgendaPage;
}());
export { AgendaPage };
var AgendaFilter = (function () {
    function AgendaFilter(fecha_desde, fecha_hasta, org_id, page, size, usrCod, documento, tipoDoc, repCodigos) {
        this.fecha_desde = fecha_desde;
        this.fecha_hasta = fecha_hasta;
        this.org_id = org_id;
        this.page = page;
        this.size = size;
        this.usrCod = usrCod;
        this.documento = documento;
        this.tipoDoc = tipoDoc;
        this.repCodigos = repCodigos;
    }
    return AgendaFilter;
}());
export { AgendaFilter };
//# sourceMappingURL=agenda.js.map